<!-- eslint-disable -->
<template>
  <div class="home-blogger" v-if="showBlogger">
    <div class="blogger-header">
      <router-link to="/blog" class="title-link">
        <div class="title">Naming Stories &amp; Inspiration</div>
      </router-link>
    </div>
    <div class="blogger-content">
      <router-link v-for="(card, index) in displayedCards" :key="index"
        :to="`/blog/${card.routename}/${card.id}`" tag="div" class="blogger-card-link">

        <div class="blogger-card">
          <img class="card-image" :src="card.image" alt="blogger image" />
          <div class="card-info">
            <div class="card-title">{{ card.title }}</div>
            <div class="card-author">
              <!-- <img class="author-avatar" :src="card.avatar" alt="author avatar" /> -->
              <div class="author-name">{{ card.author }}</div>
            </div>
          </div>
        </div>
      </router-link>
    </div>
    <div class="blogger-footer">
      <div class="pagination">
        <div class="pagination-button" @click="prevPage" :class="{ disabled: currentPage === 0 }">
          <div class="pagination-circle">
            <img src="@/assets/default/arrow-right-small_w.svg" alt="previous" class="prev-icon" />
          </div>
        </div>
        <div class="pagination-button" @click="nextPage"
          :class="{ disabled: currentPage >= maxPage }">
          <div class="pagination-circle">
            <img src="@/assets/default/arrow-right-small_w.svg" alt="next" class="next-icon" />
          </div>
        </div>
      </div>
      <router-link to="/blog" tag="div" class="view-more">
        <div class="view-more-text">View More</div>
        <img src="@/assets/default/arrow-right-small_w.svg" alt="arrow" class="view-more-icon" />
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import allBlogs from '@/data/blogs.json';

export default {
  name: 'HomeBlogger',
  data () {
    return {
      currentPage: 0,
      itemsPerPage: 4,
    };
  },
  computed: {
    ...mapGetters(['domainConfig']),
    showBlogger () {
      return this.domainConfig?.showBlog === 1;
    },
    filteredBloggerCards () {
      if (this.domainConfig && this.domainConfig.blog && this.domainConfig.blog.length) {
        return this.domainConfig.blog
          .map(id => allBlogs.find(blog => String(blog.id) === String(id)))
          .filter(blog => blog); // 过滤掉未找到的博客
      }
      return allBlogs; // 如果没有配置，返回所有博客
    },
    displayedCards () {
      const start = this.currentPage * this.itemsPerPage;
      return this.filteredBloggerCards.slice(start, start + this.itemsPerPage);
    },
    maxPage () {
      return Math.ceil(this.filteredBloggerCards.length / this.itemsPerPage) - 1;
    }
  },
  methods: {
    prevPage () {
      if (this.currentPage > 0) {
        this.currentPage--;
      }
    },
    nextPage () {
      if (this.currentPage < this.maxPage) {
        this.currentPage++;
      }
    },
    navigateToBlog (card) {
      if (card && card.id) {
        // 将标题转换为URL友好的格式
        const formattedTitle = card.title
          .toLowerCase()
          .replace(/[^\w\s-]/g, '') // 移除特殊字符
          .replace(/\s+/g, '-'); // 将空格替换为连字符

        this.$router.push(`/blog/${formattedTitle}/${card.id}`);
      }
    },
    viewAllBlogs () {
      // 导航到博客列表页面
      this.$router.push('/blog');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.home-blogger {
	padding: rem(60) 0;
	display: flex;
	flex-direction: column;
	gap: rem(24);
	align-items: flex-start;
	justify-content: flex-start;
	position: relative;

	.blogger-header {
		padding: 0 rem(180);
		display: flex;
		flex-direction: row;
		gap: rem(16);
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		position: relative;

		.title-link {
			text-decoration: none;
			cursor: pointer;
		}

		.dot {
			background: #a31984;
			border-radius: rem(100);
			width: rem(8);
			height: rem(4);
			position: relative;
		}

		.title {
			color: #fff;
			text-align: left;
			font-size: rem(24);
			line-height: rem(28);
			font-weight: 900;
			position: relative;
		}
	}

	.blogger-content {
		padding: 0 rem(180);
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: flex-start;
		gap: rem(24);
		// width: rem(1440);
		width: 100%;
		position: relative;

		.blogger-card-link {
			text-decoration: none;
			padding: rem(2);
			border-radius: rem(16);
			background: transparent;
			transition: all 0.3s ease;
			&:hover {
				background: linear-gradient(93deg, #08f 0%, #e54cba 50%, #c8ad17 100%);
			}
		}

		.blogger-card {
			position: relative;
			cursor: pointer;
			display: flex;
			flex-direction: column;
			gap: 0;
			align-items: flex-start;
			justify-content: flex-start;
			width: rem(252);
			padding: rem(8) rem(8) rem(16);
			border-radius: rem(14); // 注意比外层小一点
			background: rgb(26 26 26);
			transition: all 0.3s ease;

			.card-image {
				border-radius: 12px;
				background: lightgray 50% / cover no-repeat;
				align-self: stretch;
				height: rem(168);
				position: relative;
				object-fit: cover;
			}

			.card-info {
				padding: rem(16) rem(8) rem(0);
				display: flex;
				flex-direction: column;
				align-items: flex-start;
				justify-content: space-between;
				align-self: stretch;
				height: rem(88);
				position: relative;

				.card-title {
					color: #fff;
					text-align: left;
					font-size: rem(14);
					line-height: rem(20);
					font-weight: 700;
					position: relative;
					align-self: stretch;
					overflow: hidden;
					display: -webkit-box;
					text-overflow: ellipsis;
					-webkit-line-clamp: 2;
					-webkit-box-orient: vertical;
				}

				.card-author {
					display: flex;
					flex-direction: row;
					gap: rem(8);
					align-items: center;
					justify-content: flex-start;
					position: relative;

					.author-avatar {
						border-radius: rem(100);
						border: rem(1) solid rgba(3, 19, 58, 0.1);
						width: rem(24);
						height: rem(24);
						position: relative;
						object-fit: cover;
						aspect-ratio: 1;
					}

					.author-name {
						color: #fff;
						text-align: left;
						font-size: rem(12);
						line-height: rem(12);
						font-weight: 400;
						font-style: italic;
						position: relative;
					}
				}
			}
		}
	}

	.blogger-footer {
		padding: 0 rem(180);
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		align-self: stretch;
		position: relative;

		.pagination {
			padding: 0 rem(16);
			display: flex;
			flex-direction: row;
			gap: rem(24);
			align-items: center;
			justify-content: center;
			position: relative;

			.pagination-button {
				width: rem(28);
				height: rem(28);
				position: relative;
				cursor: pointer;

				&.disabled {
					opacity: 0.5;
					cursor: not-allowed;
				}

				.pagination-circle {
					background: linear-gradient(93deg, #08f 0%, #e54cba 50%, #c8ad17 100%);
					border-radius: rem(100);
					width: rem(28);
					height: rem(28);
					position: absolute;
					display: flex;
					align-items: center;
					justify-content: center;
				}

				.prev-icon {
					width: rem(6);
					height: rem(12);
					transform: rotate(180deg);
				}

				.next-icon {
					width: rem(6);
					height: rem(12);
				}
			}
		}

		.view-more {
			padding: rem(8) rem(16);
			display: flex;
			flex-direction: row;
			gap: rem(8);
			align-items: center;
			justify-content: flex-start;
			position: relative;
			cursor: pointer;
			transition: all 0.3s ease;
			border-radius: rem(8);
			background: var(--Linear, linear-gradient(93deg, #08f 0%, #e54cba 50%, #c8ad17 100%));

			.view-more-text {
				color: #fff;
				text-align: center;
				font-size: rem(12);
				line-height: rem(12);
				font-weight: 700;
				position: relative;
			}

			.view-more-icon {
				width: rem(6);
				height: rem(12);
			}
		}
	}

	.detect_deviece_mobile & {
		padding: rem(60) 0;

		.blogger-header {
			padding: 0 rem(16);
		}

		.blogger-content {
			padding: 0 0 0 rem(16);
			flex-direction: row;
			gap: rem(16);
			overflow-x: auto;
			// Hide scrollbar
			-ms-overflow-style: none; /* IE and Edge */
			scrollbar-width: none; /* Firefox */
			&::-webkit-scrollbar {
				display: none;
			}

			.blogger-card {
				width: rem(252);
				flex-shrink: 0;
			}
		}

		.blogger-footer {
			padding: 0 rem(16);
			justify-content: flex-start;
			.pagination {
				display: none;
			}
		}
	}
}
</style> 